/* src/app/forms/clientes/clientes.component.css */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=clientes.component.css.map */
